import { useRef } from 'react';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import { Reporting, TabSectionPropType } from 'modules/iterableGoals/types';
import { useSelector } from 'react-redux';
import { getCompletionsVsSendsMetrics } from 'modules/iterableGoals/ducks/selectors';
import {
  generateSeries,
  getGoalConversionsVsSendsChartOptions,
} from 'modules/iterableGoals/utils/completionVsSendsHelpers';
import { globalOpts, SMALL_CARD_HEIGHT } from 'modules/iterableGoals/constants/common';
import { useReportingContext } from 'modules/iterableGoals/contexts';
import { AnalyticsCard } from './AnalyticsCard';

if (typeof Highcharts === 'object') {
  HighchartsExporting(Highcharts);
  HighchartsExportData(Highcharts);
}

Highcharts.setOptions(globalOpts);

export const CompletionVsSends = ({
  loading,
  error,
  reFetchGoalAnalyticsData,
}: TabSectionPropType) => {
  const { t } = useGoalsTranslations();
  const { isRevenue, reportingBy, getReportingTranslation } = useReportingContext();
  const chartRef = useRef<HighchartsReact>(null);

  const { metrics, revenue } = useSelector(getCompletionsVsSendsMetrics);
  const series = generateSeries(reportingBy === Reporting.EVENT ? metrics : revenue, t, isRevenue);
  const options: Highcharts.Options = getGoalConversionsVsSendsChartOptions(series, t, isRevenue);

  return (
    <AnalyticsCard
      title={getReportingTranslation('title.analytics.goalConversionsVsSends')}
      height={SMALL_CARD_HEIGHT}
      loading={loading}
      error={error}
      handleReload={reFetchGoalAnalyticsData}
    >
      <HighchartsReact
        options={options}
        ref={chartRef}
        containerProps={{ style: { margin: '0', width: '100%' } }}
      />
    </AnalyticsCard>
  );
};
